import { render, staticRenderFns } from "./cinema-player-type.vue?vue&type=template&id=fd57548a&"
import script from "./cinema-player-type.vue?vue&type=script&lang=ts&"
export * from "./cinema-player-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports